import { lazy } from 'react';
import Splash from '../pages/Splash';
import Home from '../features/home/pages/HomePage';

import AddNewAddressPage from "../features/addresses/pages/AddNewAddressPage";
import UserProfilePage from "../features/profile/pages/UserProfilePage";
import ContentPage from "../features/profile/pages/ContentPage";
import ManageAddressesPage from "../features/addresses/pages/ManageAddressesPage";
import EditAddressPage from "../features/addresses/pages/EditAddressPage";
import WalletPage from "../features/profile/pages/WalletPage";
import InviteOthersPage from "../features/profile/pages/InviteOthersPage";
import ReagentsPage from "../features/profile/pages/ReagentsPage";
import EditProfilePage from "../features/profile/pages/EditProfilePage";
import ContactPage from "../features/profile/pages/ContactPage";
import NeedLogin from "../layouts/NeedLogin";
import AllCategoriesPage from "../features/home/pages/AllCategoriesPage";
import ServicesListPage from "../features/services/pages/ServicesListPage";
import ServiceProfilePage from "../features/services/pages/ServiceProfilePage";
import StoreRequestPage from "../features/requests/pages/StoreRequestPage";
import RequestsListPage from "../features/requests/pages/RequestsListPage";
import RequestProfilePage from "../features/requests/pages/RequestProfilePage";
import SearchServices from "../features/home/components/SearchServices";
import LoginWithInvitePage from "../features/auth/pages/LoginWithInvitePage";


// صفحات کم‌مصرف (با lazy)
const LoginPage = lazy(() => import('../features/auth/pages/LoginPage'));
const VerifyPage = lazy(() => import('../features/auth/pages/VerifyPage'));
const RegisterPage = lazy(() => import('../features/auth/pages/RegisterPage'));

const SelectCityPage = lazy(() => import("../features/home/pages/SelectCityPage"));



const appRoutes = [
    {
        pageId : 0,
        path: "/",
        title: 'خوش آمدید',
        component: <Splash />,
    },
    {
        pageId: 1,
        path: '/login',
        title: 'ورود به سامانه',
        component: <LoginPage />,
    },
    {
        pageId: 2,
        path: '/verify',
        title: 'تایید شماره موبایل',
        component: <VerifyPage />,
    },
    {
        pageId: 3,
        path: '/register',
        title: 'ثبت نام اولیه',
        component: <RegisterPage />,
    },
    {
        pageId: 4,
        path: '/home',
        title: 'خانه',
        component: <Home />,
    },

    {
        pageId: 5,
        path: "/categories/:id?",
        title: 'دسته بندی ها',
        component: <AllCategoriesPage />,
    },

    {
        pageId: 6,
        path: "/services/:id?",
        title: 'لیست خدمات',
        component: <ServicesListPage />,
    },

    {
        pageId: 7,
        path: "/service/:id",
        title: 'مشاهده اطلاعات خدمت',
        component: <ServiceProfilePage />,
    },

    {
        pageId: 7,
        path: "/request-options",
        title: 'تنظیم ویژگی های درخواست',
        component: <StoreRequestPage />,
    },

    {
        pageId: 8,
        path: "/requests",
        title: 'لیست درخواست ها',
        component: <RequestsListPage />,
    },

    {
        pageId: 9,
        path: "/requests/:id",
        title: 'مشاهده اطلاعات درخواست',
        component: <RequestProfilePage />,
    },

    {
        pageId: 10,
        path: "/profile",
        title: 'حساب کاربری',
        component: <UserProfilePage />,
    },
    {
        pageId: 11,
        path: "/add-address",
        title: 'افزودن آدرس',
        component: <AddNewAddressPage />,
    },
    {
        pageId : 13,
        path: "/contents/:slug",
        title: 'نمایش محتوی ',
        component: <ContentPage />,
    },
    {
        pageId : 14,
        path: "/addresses",
        title: ' مدیریت آدرس ها ',
        component: <ManageAddressesPage />,
    },
    {
        pageId : 15,
        path: "/edit-address/:id",
        title: ' مدیریت آدرس ها ',
        component: <EditAddressPage />,
    },
    {
        pageId : 16,
        path: "/wallet",
        title: ' مدیریت کیف پول ',
        component: <WalletPage />,
    },
    {
        pageId : 17,
        path: "/profile/invite-others",
        title: ' دعوت دیگران   ',
        component: <InviteOthersPage />,
    },
    {
        pageId : 18,
        path: "/reagents",
        title: 'افراد معرفی شده',
        component: <ReagentsPage />,
    },
    {
        pageId : 20,
        path: "/edit-profile",
        title: ' ویرایش پروفایل',
        component: <EditProfilePage />,
    },
    {
        pageId : 22,
        path: "/contact",
        title: 'اطلاعات تماس ',
        component: <ContactPage />,
    },
    {
        pageId : 25,
        path: "/select-city",
        title: 'انتخاب شهر پیش فرض ',
        component: <SelectCityPage />,
    },
    {
        pageId : 26,
        path: "/unauthorize",
        title: 'نیاز به احراز هویت ',
        component: <NeedLogin />,
    },
    {
        pageId : 27,
        path: "/search",
        title: 'جستجو در سرویسها ',
        component: <SearchServices />,
    },
    {
        pageId : 28,
        path: "/invite/:code",
        component: <LoginWithInvitePage />,
    },

];
export default appRoutes;
